import { render, staticRenderFns } from "./Orderer.vue?vue&type=template&id=c2c8e870&scoped=true&"
import script from "./Orderer.vue?vue&type=script&lang=ts&"
export * from "./Orderer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2c8e870",
  null
  
)

export default component.exports